"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_CONDITION_COMPARISON_OPERATORS = exports.COMPARISON_OPERATORS = exports.FIELD_CONDITION_JOIN_OPERATORS = exports.JOIN_OPERATORS = void 0;
exports.JOIN_OPERATORS = {
    AND: 'AND',
    OR: 'OR',
};
/**
 * @deprecated Use the new {@link JOIN_OPERATORS} enum instead.
 */
exports.FIELD_CONDITION_JOIN_OPERATORS = exports.JOIN_OPERATORS;
exports.COMPARISON_OPERATORS = {
    EQ: 'EQ',
    NE: 'NE',
    GT: 'GT',
    LT: 'LT',
    GE: 'GE',
    LE: 'LE',
    BT: 'BT',
    CONTAINS: 'CONTAINS',
    NOTCONTAINS: 'NOTCONTAINS',
    ISPRESENT: 'ISPRESENT',
    ISNOTPRESENT: 'ISNOTPRESENT',
};
/**
 * @deprecated Use the new {@link COMPARISON_OPERATORS} enum instead.
 */
exports.FIELD_CONDITION_COMPARISON_OPERATORS = exports.COMPARISON_OPERATORS;
const processFilter = (rootFilter, conditionCheckValues) => {
    let filterValid = false;
    if (rootFilter && conditionCheckValues) {
        if (rootFilter.joinOperator &&
            rootFilter.filters &&
            rootFilter.filters.length) {
            const filterResults = rootFilter.filters.map((filter) => {
                return processFilter(filter, conditionCheckValues);
            });
            if (rootFilter.joinOperator === exports.JOIN_OPERATORS.AND) {
                filterValid = true;
                filterResults.forEach((filterResult) => {
                    if (!filterResult) {
                        filterValid = false;
                    }
                });
            }
            else if (rootFilter.joinOperator === exports.JOIN_OPERATORS.OR) {
                filterValid = false;
                filterResults.forEach((filterResult) => {
                    if (filterResult) {
                        filterValid = true;
                    }
                });
            }
        }
        else if (rootFilter.fieldId) {
            const checkValue = conditionCheckValues[rootFilter.fieldId]
                ? conditionCheckValues[rootFilter.fieldId]
                : undefined;
            const processComparison = (comparisonValue) => {
                if (filterValid) {
                    return; // when the `filterValid` is true we don't need to process the rest of the comparisons
                }
                const getFieldValue = (fieldMapping) => {
                    return conditionCheckValues[fieldMapping]
                        ? conditionCheckValues[fieldMapping]
                        : undefined;
                };
                const toCheckValue1 = rootFilter.value1
                    ? rootFilter.value1.indexOf('FIELD:') === 0
                        ? getFieldValue(rootFilter.value1.split('FIELD:')[1])
                        : rootFilter.value1
                    : undefined;
                const toCheckValue2 = rootFilter.value2
                    ? rootFilter.value2.indexOf('FIELD:') === 0
                        ? getFieldValue(rootFilter.value2.split('FIELD:')[1])
                        : rootFilter.value2
                    : undefined;
                if (comparisonValue) {
                    if (rootFilter.operator === exports.COMPARISON_OPERATORS.EQ) {
                        filterValid = comparisonValue === toCheckValue1;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.NE) {
                        filterValid = comparisonValue !== toCheckValue1;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.GE) {
                        filterValid =
                            typeof toCheckValue1 !== 'undefined'
                                ? parseFloat(`${comparisonValue}`) >=
                                    parseFloat(`${toCheckValue1}`)
                                : false;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.GT) {
                        filterValid =
                            typeof toCheckValue1 !== 'undefined'
                                ? parseFloat(`${comparisonValue}`) >
                                    parseFloat(`${toCheckValue1}`)
                                : false;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.LE) {
                        filterValid =
                            typeof toCheckValue1 !== 'undefined'
                                ? parseFloat(`${comparisonValue}`) <=
                                    parseFloat(`${toCheckValue1}`)
                                : false;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.LT) {
                        filterValid =
                            typeof toCheckValue1 !== 'undefined'
                                ? parseFloat(`${comparisonValue}`) <
                                    parseFloat(`${toCheckValue1}`)
                                : false;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.BT) {
                        filterValid =
                            typeof toCheckValue1 !== 'undefined' &&
                                typeof toCheckValue2 !== 'undefined'
                                ? parseFloat(`${comparisonValue}`) >=
                                    parseFloat(`${toCheckValue1}`) &&
                                    parseFloat(`${comparisonValue}`) <=
                                        parseFloat(`${toCheckValue2}`)
                                : false;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.CONTAINS) {
                        filterValid =
                            typeof toCheckValue1 !== 'undefined'
                                ? comparisonValue.contains(toCheckValue1)
                                : false;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.NOTCONTAINS) {
                        filterValid =
                            typeof toCheckValue1 !== 'undefined'
                                ? !comparisonValue.contains(toCheckValue1)
                                : false;
                    }
                }
                else {
                    if (rootFilter.operator === exports.COMPARISON_OPERATORS.EQ) {
                        filterValid = comparisonValue === toCheckValue1;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.NE) {
                        filterValid = comparisonValue !== toCheckValue1;
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.CONTAINS) {
                        filterValid = !!comparisonValue === !!toCheckValue1; // will coerce null and undefined to false, but if value1 is provided evaluation will be false
                    }
                    else if (rootFilter.operator === exports.COMPARISON_OPERATORS.NOTCONTAINS) {
                        filterValid = !!comparisonValue !== !!toCheckValue1; // will coerce null and undefined to false, but if value1 is provided evaluation will be true
                    }
                    else {
                        filterValid = false;
                    }
                }
            };
            if (checkValue) {
                if (rootFilter.operator === exports.COMPARISON_OPERATORS.ISPRESENT) {
                    filterValid = true;
                }
                else if (rootFilter.operator === exports.COMPARISON_OPERATORS.ISNOTPRESENT) {
                    filterValid = false;
                }
                else {
                    if (Array.isArray(checkValue)) {
                        for (const value of checkValue) {
                            processComparison(value);
                        }
                    }
                    else {
                        const parts = checkValue.split(';');
                        for (const value of parts) {
                            processComparison(value);
                        }
                    }
                }
            }
            else {
                if (rootFilter.operator === exports.COMPARISON_OPERATORS.ISNOTPRESENT) {
                    filterValid = true;
                }
                else if (rootFilter.operator === exports.COMPARISON_OPERATORS.ISPRESENT) {
                    filterValid = false;
                }
                else {
                    processComparison(undefined);
                }
            }
        }
    }
    return !!filterValid;
};
const filterProcessor = (rootCondition, values) => {
    let isConditionalVisible = true;
    let isConditionalEditable = true;
    if (rootCondition) {
        const filterValid = processFilter(rootCondition.rootFilter, values);
        if (filterValid) {
            if (rootCondition.trueState === 'hidden') {
                isConditionalVisible = false;
                isConditionalEditable = false;
            }
            else if (rootCondition.trueState === 'readonly') {
                isConditionalVisible = true;
                isConditionalEditable = false;
            }
            else if (rootCondition.trueState === 'editable') {
                isConditionalVisible = true;
                isConditionalEditable = true;
            }
        }
        else {
            if (rootCondition.falseState === 'hidden') {
                isConditionalVisible = false;
                isConditionalEditable = false;
            }
            else if (rootCondition.falseState === 'readonly') {
                isConditionalVisible = true;
                isConditionalEditable = false;
            }
            else if (rootCondition.falseState === 'editable') {
                isConditionalVisible = true;
                isConditionalEditable = true;
            }
        }
    }
    return { isConditionalVisible, isConditionalEditable };
};
exports.default = filterProcessor;
//# sourceMappingURL=filter-processor.js.map